import { useEffect, useState } from "react";
import { fetchWithToken } from "../utilities/fetchWithToken";
import { BASE_URL } from "../utilities/BASE_URL";
import "./leaderboard.css";

const Leaderboard = () => {
    const [players, setPlayers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchWithToken(`${BASE_URL}/playerInfo/leaderboard`)
            .then(res => res.json())
            .then(data => {
                setPlayers(data);
                setLoading(false);
            })
            .catch(() => {
                setError("Failed to load leaderboard");
                setLoading(false);
            });
    }, []);

    const rankClass = (index) => {
        if (index === 0) return "rank-1";
        if (index === 1) return "rank-2";
        if (index === 2) return "rank-3";
        return "";
    };

    return (
        <div className="leaderboard-container">
            <h2>Leaderboard</h2>
            {loading && <p>Loading...</p>}
            {error && <p style={{ color: "#ff3d6e" }}>{error}</p>}
            <table>
                <thead>
                    <tr>
                        <th>Rank</th>
                        <th>Player</th>
                        <th>Chips</th>
                    </tr>
                </thead>
                <tbody>
                    {players.map((player, index) => (
                        <tr key={player.username} className={rankClass(index)}>
                            <td>{index + 1}</td>
                            <td>{player.username}</td>
                            <td>{player.chips.toLocaleString()}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Leaderboard;
